import React, { useEffect, useState } from 'react';
import './footer.scss';

interface VersionProps {
    version: string
}

export default function Footer(props: VersionProps) {

    return (
        <footer>
            <div>Copyright © 2005-2023 Userful Corp. All rights reserved.</div>
      </footer>
    )
}

